// Action to toggle the state
export const toggleDemo = () => {
  return {
    type: "TOGGLE_DEMO", // Action type
  };
};

// Action to explicitly set the tutorial state (expanded or collapsed)
export const setDemo = (demo) => {
  return {
    type: "SET_DEMO", // Action type
    payload: demo, // Pass the new state as payload
  };
};

export const setDemoObj = (demo) => {
  return {
    type: "SET_DEMO_OBJ", // Action type
    payload: demo, // Pass the new state as payload
  };
};
